module.exports = __webpack_public_path__ + "c_static/img/tip3.38dc444.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/tip3.png
// module id = 8c9p
// module chunks = 33